import Component from '../../js/_Component';
import Modal from '../../js/util/_Modal';

const CNAME = 'c-block-popup';

const WHITELISTED_PAGES = [
	'/xxxxxxxx/', // Always leave at least one otherwise it'll match everything.
	'/$',
];

const WHITELIST_REGEX = new RegExp(`^(?:${WHITELISTED_PAGES.join('|')})`);
const MAX_DURATION = 20;

/*
	Want to see this popup?
	ComponentClass.getComponent(document.querySelector('.c-block-popup')).showPopup();


	Want to test this popup against logic?
	ComponentClass.getComponent(document.querySelector('.c-block-popup')).validShowPopup();
*/

export default class BlockPopup extends Component {


	private originalParent: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		this.originalParent = this.element.parentElement;

		// Whitelist for Timer
		if (window.location.pathname.match(WHITELIST_REGEX)) {
			this.startTimer();
		}

		// Check against page views
		this.checkPageViews();

		// Check against downloads
		this.checkDownload();

		// Check for special pages
		this.checkSpecialPages();

		if (window.location.hash == '#newsletter-signup') {
			this.showPopup(true);
		}

		//add watcher for hashchange
        this.hashWatcher(this);
	}

	hashWatcher(self) {
		window.addEventListener('hashchange', function(){
			// if there are more hashes to watch in future
			// make this a switch or array of hashes
			if(window.location.hash === '#newsletter-signup'){
				self.showPopup(true);
			}
		});
	}

	startTimer() {
		let time = parseInt(window.localStorage.getItem('popup_waitTime')) | 0;
		if ((time > -1) && (time < MAX_DURATION)) {
			let interval = setInterval(() => {
				time += 1;
				if (time > MAX_DURATION) {
					clearInterval(interval);
					window.localStorage.setItem('popup_waitTime', `-1`); // -1 prevents the popup from happening again.

					this.validShowPopup();
				} else {
					window.localStorage.setItem('popup_waitTime', `${time}`);
				}
			}, 1000);
		}
	}

	restartTimer() {
		window.localStorage.removeItem('popup');
		this.startTimer();
	}

	showPopup(force = false) {
		// If a modal already exists, don't display more.
		if (document.querySelector('.modal')) {
			return false;
		}

		if(!force && window.localStorage.getItem( 'popup_hideForever' ) == "true") {
			return;
		}

		let modal = new Modal(this.element, 'no-border');
		modal.showPanel(0);
		this.element.classList.add('m-show');

		let closeButton = this.element.querySelector('button.m-closepopup');
		let closeAction = () => modal.close();

		closeButton.addEventListener('click', closeAction);

		modal.onClose = () => {
			closeButton.removeEventListener('click', closeAction);
			this.element.classList.remove('m-show');
			this.originalParent.appendChild(this.element);
			// clear hash to window can be popped again if desired
            history.replaceState("",null,window.location.pathname);
			// Hide popup forever.
			window.localStorage.setItem( 'popup_hideForever', 'true' );

			//reset block affiliation form
			const form =  Component.getComponent(this.element.querySelector('.c-block-affiliation-form'));
			form.reset();
		};
	}

	checkDownload() {
		// If we need to restrict this to a specific template...
		/*
		let overviewSearchPage = document.querySelector('.c-page-overview-search');
		if(!overviewSearchPage){
			return false;
		}
		*/

		// Make sure that we can work with the storage object
		let popup_filesDownloaded = window.localStorage.getItem('popup_filesDownloaded');

		// If we don't have a value, set a default
		if (popup_filesDownloaded === null){
			window.localStorage.setItem('popup_filesDownloaded',"0");
		}

		// Add listener to look for links that are considered "valid" by looking for this popupFile class.
		document.addEventListener("click",(e) => {
			if(e.target){
				let targetEl = e.target as HTMLElement;
				if(targetEl.classList.contains("popupfile") || targetEl.closest("a.popupfile") || targetEl.closest("button.popupfile")) {
					popup_filesDownloaded = window.localStorage.getItem('popup_filesDownloaded');
					let popup_filesDownloadedNum = parseInt(popup_filesDownloaded);

					if(popup_filesDownloadedNum !== NaN) {
						// Real number. Increase and write back.
						popup_filesDownloadedNum = popup_filesDownloadedNum + 1;
						window.localStorage.setItem('popup_filesDownloaded',`${popup_filesDownloadedNum}`);

						// Check to see if we should show the popup.
						if (popup_filesDownloadedNum >= 1){
							this.validShowPopup();
						}
					}
				}
			}
		});
	}

	checkPageViews() {
		let genericPage = document.querySelector('.c-page-page') as HTMLElement;
		let newViewCount = 0;

		if (genericPage){
			// We found a generic page component. Increase the count.
			let popup_pagesSeen = window.localStorage.getItem('popup_pagesSeen');
			let popup_pagesSeenNum = parseInt(popup_pagesSeen,10);
			if (popup_pagesSeen !== null) {
				if(popup_pagesSeenNum !== NaN) {
					// Found existing count, add 1
					newViewCount = popup_pagesSeenNum + 1;
				} else {
					// No page has ever been recorded, set as 1
					newViewCount = 1;
				}
			} else {
				// Failed to get a view count from local storage, attempt to set back to 1
				newViewCount = 1;
			}

			// Write back to local storage
			window.localStorage.setItem('popup_pagesSeen',`${newViewCount}`);

			// Check against view count
			if (newViewCount >= 2){
				this.validShowPopup();
			}
		}
	}

	checkPopupViews(){
		// This is unused but could be used if conditions change to need multiple showings;

		let showPopup = true as Boolean;

		// Have we already seen this too many times?
		let popup_timesSeen = window.localStorage.getItem('popup_timesSeen');
		if (popup_timesSeen !== null){
			if (parseInt(popup_timesSeen,10) > 1){
				showPopup = false;
				// Hide forever
				window.localStorage.setItem('popup_hideForever',"true");
			}
		}

		// Can we show it?
		if (showPopup == true) {
			this.validShowPopup();
		}

	}


	validShowPopup() {
		/*
		 * Logic of when this should appear.
		 * After a user has downloaded 2 items on School Recipe/Tools & Resources / Project Produce Case Study / Project & Signs
		 * OR
		 * Homepage 30s timer
		 * OR
		 * Visits 3 'generic pages'
		 *
		 * Granted these conditions can conflict. What if we start on downloads, then move to homepage etc...
		 */


		let showPopup = true as Boolean;

		// Has it already been decided to never see this popup again?
		if (window.localStorage.getItem('popup_hideForever') == "true"){
			showPopup = false;
		}

		// Can we show it?
		if (showPopup == true) {
			this.showPopup();
		}

	}

	checkSpecialPages(){
		// If we find any of the following, increase the count.
		let specialPage = document.querySelector('.c-page-project-produce, .c-page-recipe, .c-page-home-recipes') as HTMLElement;
		let newViewCount = 0;

		if (specialPage){
			// We found a generic page component. Increase the count.
			let popup_specialPagesSeen = window.localStorage.getItem('popup_specialPagesSeen');
			let popup_specialPagesSeenNum = parseInt(popup_specialPagesSeen,10);
			if (popup_specialPagesSeen !== null) {
				if(popup_specialPagesSeenNum !== NaN) {
					// Found existing count, add 1
					newViewCount = popup_specialPagesSeenNum + 1;
				} else {
					// No page has ever been recorded, set as 1
					newViewCount = 1;
				}
			} else {
				// Failed to get a view count from local storage, attempt to set back to 1
				newViewCount = 1;
			}

			// Write back to local storage
			window.localStorage.setItem('popup_specialPagesSeen',`${newViewCount}`);

			// Check against view count
			if (newViewCount >= 2){
				this.validShowPopup();
			}
		}

	}

}

Component.register(BlockPopup, 'BlockPopup');
